// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-user-info[data-v-c5764f4a]{cursor:pointer}.top-user-info .rep[data-v-c5764f4a]{vertical-align:middle}.clickable[data-v-c5764f4a]{cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
